import React from 'react';
import PropTypes from 'prop-types';
import '../components.gallery.scss';

const ExternalLink = ({ href, className, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className={`wz-primary-link ${className}`}>
        {children}
    </a>
);

ExternalLink.propTypes = {
    href: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

ExternalLink.defaultProps = {
    className: ''
};

export default ExternalLink;
